import { defineNuxtPlugin } from '#app'
import posthog from 'posthog-js'

export default defineNuxtPlugin(nuxtApp => {
   const runtimeConfig = useRuntimeConfig();
   const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
      api_host: runtimeConfig.public.posthogHost,
      defaults: runtimeConfig.public.posthogDefaults as unknown as undefined,
      loaded: () => {
         // if (import.meta.env.MODE === 'development') posthog.debug();
      },
   });

   return {
      provide: {
         posthog: () => posthogClient
      }
   }
})